const localStorageConstants = {
  accessToken: "accessToken",
  userId: "userId",
};

export default localStorageConstants;
